import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';

import { AffectationService } from '../service/AffectationService';
import { CiteService } from '../service/CiteService';
import { UtilisateurService } from '../service/UtilisateurService';
import { VilleService } from '../service/VilleService';
import { SessionService } from '../service/SessionService';

export default class AffectationCite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matriculeSearch: '',
      searchResult: null,
      searchMessage: '',
      session: null,
      cites: [],
      villes: [],
      selectedCite: null,
      selectedVille: null,
      user: null,
      stats: {
        girls_to_assign: 0,
        boys_to_assign: 0,
        girls_assigned: 0,
        boys_assigned: 0,
        total_to_assign: 0,
        total_assigned: 0
      },
      admissibles: [],
      showAdmissiblesModal: false,
      assignedList: [],
      showAssignedModal: false,
      loading: false
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.searchStudent = this.searchStudent.bind(this);
    this.loadCites = this.loadCites.bind(this);
    this.loadStats = this.loadStats.bind(this);
    this.assignStudent = this.assignStudent.bind(this);
    this.openAdmissibles = this.openAdmissibles.bind(this);
    this.openAssignedList = this.openAssignedList.bind(this);

    this.affectationService = new AffectationService()
    this.citeService = new CiteService()
    this.userService = new UtilisateurService()
    this.villeService = new VilleService()
    this.sessionService = new SessionService()
  }

  componentDidMount() {
    
    const data = localStorage.getItem('user');
    if(data){
      const user = JSON.parse(data)
      console.log(user)
      const idDirection = user.idDirection
      this.sessionService.getSessionDirection(idDirection).then(data => {
      const annees = data
      const maxIdAnnee = annees.reduce((max, item) =>
        item.idAnnee > max.idAnnee ? item : max
      );
      console.log(maxIdAnnee)
      this.setState({session: maxIdAnnee})
    })
    .catch(error => {
      console.log(error.response.data)
    })
      this.villeService.getVilleDirection(user.idDirection).then(resp => {
        let villes = Array.isArray(resp) ? resp : []
        if(villes.length>0){
           villes = villes.filter(ville => ville.nomVille !== "SAABA");
        }
        this.setState({ villes : villes });
    })
    .catch(error => {
        console.log(error)
    })
      this.setState({user : user})
    }
    else console.log("Aucun utilisateur trouvé dans le localStorage")
  
  }

  onInputChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onVilleSelected(e){
    const ville = e.value
    this.setState({selectedVille : ville})
    this.loadCites(ville.idVille)
  }
  onCiteSelected(e){
    const cite = e.value
    this.setState({selectedCite : cite})
    this.loadStats(cite.idCite, this.state.session.idSessionCenou);
  }

  loadCites(idVille) {
    this.citeService.getCitesVille(idVille).then(data => {
        const cites = Array.isArray(data) ? data : []
        this.setState({ cites :  cites});

    })
    .catch(err => {
        console.error(err);
        this.setState({ cites: [] });
      });
    
  }

  loadStats(idCite, idSession) {
    this.affectationService.getAssignmentStats(idCite, idSession)
      .then(data => {
        console.log(data)
        const donnees = {
          girls_to_assign: data.totalFillesAffectatations,
          boys_to_assign: data.totalGarconsAffectatations,
          girls_assigned: data.totalFillesDejaAffectes,
          boys_assigned: data.totalGarconsDejaAffectes,
          total_to_assign: data.totatAffectations,
          total_assigned: data.totatDejaAffectes
        }
        this.setState({ stats: donnees });
      })
      .catch(err => {
        console.error(err);
      });
  }

  searchStudent() {
    const matricule = this.state.matriculeSearch && this.state.matriculeSearch.trim();
    if (!matricule) {
      this.setState({ searchMessage: 'Saisir un matricule', searchResult: null });
      return;
    }
    console.log(this.state.session)
    this.setState({ loading: true, searchMessage: '', searchResult: null });
    this.userService.findByStudent(matricule, this.state?.session?.idSessionCenou)
      .then(resp => {
        let student = null;
        if (resp === null) {
          student = null;
        } else if (resp.idEtudiant || resp.ine || resp.nom) {
          student = resp;
        } else if (Array.isArray(resp) && resp.length > 0) {
          student = resp[0];
        }

        if (student) {
          this.setState({ searchResult: student, searchMessage: '' });
        } else {
          this.setState({ searchResult: null, searchMessage: "L'étudiant n'existe pas" });
        }
      })
      .catch(err => {
        console.log(err.response)
        console.error(err);
        this.setState({ searchResult: null, searchMessage: err.response.data.message || "Erreur lors de la recherche" });
      })
      .finally(() => this.setState({ loading: false }));
  }

  assignStudent() {
    const { searchResult, selectedCite } = this.state;
    if (!searchResult) {
      alert("Recherche d'abord un étudiant valide.");
      return;
    }
    if (!selectedCite) {
      alert("Sélectionne une cité.");
      return;
    }
    if(this.state.searchResult.idEtudiant && this.state.selectedCite.idCite && this.state.session.idSessionCenou) {
      const payload = { idEtudiant: this.state.searchResult.idEtudiant, idCite: this.state.selectedCite.idCite, idSessionCenou : this.state.session.idSessionCenou };
      //console.log(payload)

    this.setState({ loading: true });
    this.affectationService.assignStudent(payload)
      .then(() => {
        this.loadStats(this.state.selectedCite.idCite, this.state.session.idSessionCenou);
        alert("Affectation enregistrée avec succès.");
        this.setState({ searchResult: null, matriculeSearch: '', selectedCite: null, searchMessage: '',session : null });
      })
      .catch(err => {
        console.log(err.response);
        console.error(err);
        alert(err.response.data.message || "Erreur lors de l'enregistrement de l'affectation.");
      })
      .finally(() => this.setState({ loading: false }));
    }
    
  }

  openAdmissibles() {
    this.setState({ loading: true });
    this.affectationService.getAdmissibles(this.state.user.idDirection, this.state.session.idAnnee)
      .then(data => {
        console.log(data)
        this.setState({ admissibles: Array.isArray(data) ? data : [], showAdmissiblesModal: true });
      })
      .catch(err => {
        console.error(err);
        alert("Erreur récupération liste des admissibles");
      })
      .finally(() => this.setState({ loading: false }));
  }

  openAssignedList() {
    const citeId = this.state.selectedCite;
    this.setState({ loading: true });
    this.affectationService.getAssignedList(citeId.idCite, this.state.session.idAnnee)
      .then(data => {
        console.log(data)
        this.setState({ assignedList: Array.isArray(data) ? data : [], showAssignedModal: true });
      })
      .catch(err => {
        console.error(err);
        alert("Erreur récupération liste des affectés");
      })
      .finally(() => this.setState({ loading: false }));
  }

  getComputedValues() {
    const s = this.state.stats;
    const girls_remaining = Math.max(0, (s.girls_to_assign || 0) - (s.girls_assigned || 0));
    const boys_remaining = Math.max(0, (s.boys_to_assign || 0) - (s.boys_assigned || 0));
    const total_remaining = Math.max(0, (s.total_to_assign || 0) - (s.total_assigned || 0));
    return { girls_remaining, boys_remaining, total_remaining };
  }

  
  studentColumns() {
    return (
      <div>
        <div><strong>INE:</strong> {this.state.searchResult.ine}</div>
        <div><strong>Nom:</strong> {this.state.searchResult.nomEtudiant}</div>
        <div><strong>Prénom:</strong> {this.state.searchResult.prenomEtudiant}</div>
        <div><strong>Sexe:</strong> {this.state.searchResult.sexeEtudiant}</div>
        <div><strong>Téléphone:</strong> {this.state.searchResult.telEtudiant}</div>
        <div><strong>Email:</strong> {this.state.searchResult.emailEtudiant}</div>
        <div><strong>Université:</strong> {this.state.searchResult.universite}</div>
        <div><strong>Filière:</strong> {this.state.searchResult.filiere}</div>
      </div>
    );
  }

  render() {
    const { matriculeSearch, searchResult, searchMessage, cites, selectedCite, villes, selectedVille, admissibles, showAdmissiblesModal, assignedList, showAssignedModal, loading } = this.state;
    const stats = this.state.stats || {};
    const computed = this.getComputedValues();

    return (
      <div className="housing-assignment-module">
        <h3>Affectation - Cités universitaires</h3>

        <div className="p-grid" style={{ marginBottom: 16 }}>
          <div className="p-col-4">
            <label>INE</label><br />
            <InputText name="matriculeSearch" value={matriculeSearch} onChange={this.onInputChange} placeholder="Saisir INE" />
            <Button label="Rechercher" icon="pi pi-search" onClick={this.searchStudent} style={{ marginLeft: 8 }} />
          </div>

          <div className="p-col-3">
            <label>Sélectionner la ville</label><br />
            <Dropdown value={this.state.selectedVille} options={this.state.villes} optionLabel="nomVille"  onChange={(e) => {this.onVilleSelected(e)} } placeholder="Choisir une ville" />
          </div>

          <div className="p-col-5">
            <label>Sélectionner la cité</label><br />
            <Dropdown value={this.state.selectedCite} optionLabel='nomCite' options={this.state.cites} onChange={(e) => {this.onCiteSelected(e)} } placeholder="Choisir une cité" />
            <Button label="Enregistrer affectation" icon="pi pi-save" onClick={this.assignStudent} style={{ marginLeft: 8, marginTop: 8 }} />
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          {searchMessage && <div className="p-messages p-messages-warn">{searchMessage}</div>}
          {searchResult &&
            <Panel header="Étudiant trouvé">
              {this.studentColumns()}
            </Panel>
          }
        </div>

        <Panel header="Statistiques d'affectation" style={{ marginBottom: 12 }}>
          <div className="p-grid">
            <div className="p-col-4">
              <h4>Filles</h4>
              <div>À affecter: {stats.girls_to_assign || 0}</div>
              <div>Déjà affectées: {stats.girls_assigned || 0}</div>
              <div>Restant: {computed.girls_remaining}</div>
            </div>
            <div className="p-col-4">
              <h4>Garçons</h4>
              <div>À affecter: {stats.boys_to_assign || 0}</div>
              <div>Déjà affectés: {stats.boys_assigned || 0}</div>
              <div>Restant: {computed.boys_remaining}</div>
            </div>
            <div className="p-col-4">
              <h4>Total</h4>
              <div>À affecter: {stats.total_to_assign || 0}</div>
              <div>Déjà affectés: {stats.total_assigned || 0}</div>
              <div>Restant: {computed.total_remaining}</div>
            </div>
          </div>
        </Panel>

        <div style={{ marginBottom: 12 }}>
          <Button label="Voir les admissibles" icon="pi pi-list" onClick={this.openAdmissibles} style={{ marginRight: 8 }} />
          <Button label="Voir les affectés" icon="pi pi-users" onClick={this.openAssignedList} />
        </div>

        
        <Dialog header="Admissibles pour l'hébergement" visible={showAdmissiblesModal} style={{ width: '70%' }} modal onHide={() => this.setState({ showAdmissiblesModal: false })}>
          <DataTable value={admissibles} paginator rows={10}>
            {/*<Column field="idDossier" header="idDossier" />*/}
            <Column field="ine" header="INE" />
            <Column field="nomEtudiant" header="Nom" />
            <Column field="prenomEtudiant" header="Prénom" />
            <Column field="sexeEtudiant" header="Sexe" />
            <Column field="telEtudiant" header="Téléphone" />
            <Column field="villeOrientation" header="Ville" />
          </DataTable>
        </Dialog>

        
        <Dialog header="Étudiants déjà affectés" visible={showAssignedModal} style={{ width: '70%' }} modal onHide={() => this.setState({ showAssignedModal: false })}>
          <DataTable value={assignedList} paginator rows={10}>
            <Column field="ine" header="INE" />
            <Column field="nomEtudiant" header="Nom" />
            <Column field="prenomEtudiant" header="Prénom" />
            <Column field="nomCite" header="Cité" />
          </DataTable>
        </Dialog>

        {loading && <div style={{ marginTop: 12 }}>Chargement...</div>}
      </div>
    );
  }
}
